// Header Hover Blur Effect
(function() {
  'use strict';

  // Create blur cursor element
  const blurCursor = document.createElement('div');
  blurCursor.className = 'header-blur-cursor';
  document.body.appendChild(blurCursor);

  let cursorX = 0;
  let cursorY = 0;
  let blurX = 0;
  let blurY = 0;
  const ease = 0.12; // 慣性の強さ（小さいほど遅れる）

  // ホワイトリスト: この中だけカーソルエフェクト有効
  const enabledSelectors = [
    'header',
    '.header',
    '#shopify-section-header',
    '.fullpage-scroll-wrapper',
    '.about-hero',
    '.about-content-card',
    '.section-about-hero',
    '[class*="section-about"]'
  ];

  // Update target cursor position
  function updateCursorPosition(e) {
    cursorX = e.clientX;
    cursorY = e.clientY;
  }

  // Animate blur with inertia
  function animateBlur() {
    // 現在位置からターゲット位置へ少しずつ近づく（慣性効果）
    blurX += (cursorX - blurX) * ease;
    blurY += (cursorY - blurY) * ease;

    blurCursor.style.left = blurX + 'px';
    blurCursor.style.top = blurY + 'px';

    requestAnimationFrame(animateBlur);
  }

  // Track mouse movement
  document.addEventListener('mousemove', updateCursorPosition);

  // ホワイトリスト方式: 有効エリア内のみブラーカーソルを表示
  document.addEventListener('mouseover', (e) => {
    // ホワイトリストのセレクターに一致するか確認
    const isInEnabledArea = enabledSelectors.some(selector => e.target.closest(selector));

    if (!isInEnabledArea) {
      // 有効エリア外: 非表示
      blurCursor.style.opacity = '0';
      blurCursor.classList.remove('on-image', 'on-about-bg');
    } else {
      // 有効エリア内: 表示
      blurCursor.style.opacity = '1';

      const isOnImage = e.target.tagName === 'IMG' || e.target.closest('picture');
      // About 2枚目カード：背景画像部分は大きいブラー、テキスト部分は小さいブラー
      const aboutSecondCard = e.target.closest('.about-content-card[data-bg-image]');
      const aboutTextArea = e.target.closest('.about-content-card__text');

      // About 2枚目カードの背景画像部分（テキストエリア以外）
      if (aboutSecondCard && !aboutTextArea) {
        blurCursor.classList.add('on-about-bg');
        blurCursor.classList.remove('on-image');
      } else if (isOnImage) {
        // img上ではon-imageクラスを追加
        blurCursor.classList.add('on-image');
        blurCursor.classList.remove('on-about-bg');
      } else {
        blurCursor.classList.remove('on-image', 'on-about-bg');
      }
    }
  });

  // Start animation loop
  animateBlur();

  // Find all header elements to track
  function initializeHeaderBlur() {
    // Select all interactive elements in the header and about nav links
    const headerSelectors = [
      '.header-bar-inner a',
      '.header-bar-inner button',
      '.hdr-nav-desktop a',
      '.hdr-menu-button',
      '.header--logo',
      '.hdr-st-item a',
      '.hdr-st-item button',
      '.cart-icon--bubble',
      '#SiteHeaderInner a',
      '#SiteHeaderInner button',
      '.about-nav-links a' // Aboutページのナビリンク
    ];

    const headerElements = document.querySelectorAll(headerSelectors.join(', '));

    headerElements.forEach(element => {
      element.addEventListener('mouseenter', () => {
        blurCursor.classList.add('active');
      });

      element.addEventListener('mouseleave', () => {
        blurCursor.classList.remove('active');
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHeaderBlur);
  } else {
    initializeHeaderBlur();
  }

  // Re-initialize when header is dynamically loaded (Shopify sections)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('header') || event.target.querySelector('.header')) {
      setTimeout(initializeHeaderBlur, 100);
    }
  });
})();
